/* eslint-disable warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';

import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class IndexRoute extends Route {
  queryParams = {
    offset: {
      refreshModel: true,
    },
  };

  // Services
  @service
  session;

  @service
  store;

  model(params) {
    let offset = 0;
    if (!isEmpty(params.offset)) {
      let temp = Number(params.offset);
      if (!Number.isNaN(temp) && temp > 0) {
        offset = temp;
      }
    }

    return hash({
      globalNotices: this.store.query('posts/globalnotice', {
        perPage: 20,
        offset,
        schoolId: this.session.activeSchool,
      }),
    });
  }
}
